module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Header/images/defeat-ribbon.4b0d144d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Header/images/defeat-ribbon.png
// module id = 3233
// module chunks = 11